




































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ShowText from "./showText.vue";
import { handleRetain } from "../../../../../common/untils/formData";
import { stampToTime } from "../../../../../common/untils/newUtils";
import { newFenshiJump } from "../../../../../common/untils/newUtils";

const dataName: any = {
  1: "price",
  2: "zhangfu",
  3: "finalztsj"
};
const win: any = window;
@Component({
  components: {
    ShowText
  },
  filters: {
    changeFilter(value: any) {
      if(!value && String(value) != '0') {
        return '--'
      }
      return handleRetain(value, 2) + "%";
    },
    timerFilter: (value: any) => {
      if(!value) {
        return '--'
      }
      return stampToTime(value);
    },
    latestFilter: (value: any) => {
      if (value) {
        return handleRetain(value, 2);
      } else {
        return "--";
      }
    }
  }
})
export default class StockTable extends Vue {
  @Prop({ default: 1 }) private readonly topNum?: number | string;
  @Prop() private readonly listorigin?: any;

  private slideTop = [
    { title: "股票名称" },
    { title: "最新", sortKey: "latest" },
    { title: "涨幅", sortKey: "change_rate" },
    { title: "最后涨停时间", sortKey: "last_limit_up_time" }
  ];

  private list: any = [];
  private renderList: any = [];
  private maidian = "free_ztjj.zqfk.";

  private moreList: any = [];
  private showMoreList = false;
  private showMoreIcon = false;

  private showlist = true;
  private isExpend = "";
  private sort = "asc";
  private nowIndex = 3;
  private prefix = "创";
  private changeDataSort(index: number) {
    if (index == 0) {
      return;
    }
    if (this.nowIndex !== index) {
      this.sort = index !== 0 ? "desc" : "asc";
    }
    this.nowIndex = index;
    if (this.sort === "desc") {
      // console.log("开始asc");

      this.sort = "asc";
      // const tempList = this.list.sort(this.sortData("asc", index));
      this.myBubbleSrot(this.list, "desc", this.sortData("asc", index));

      this.renderList = this.list.slice(0, 5);
      this.moreList = this.list.slice(5);
    } else {
      this.sort = "desc";
      // const tempList = this.list.sort(this.sortData("desc", index));
      this.myBubbleSrot(this.list, "asc", this.sortData("desc", index));

      this.renderList = this.list.slice(0, 5);

      this.moreList = this.list.slice(5);
    }
    win.hxmClickStat(
      `${this.maidian}all.${this.topNum}.${dataName[this.nowIndex]}.${
        this.sort
      }`,
      { url_ver: "F10-1725" }
    );
  }

  private created() {
    if (this.listorigin && this.listorigin.length > 0) {
      this.list = this.listorigin;
      this.initData();
    } else {
      this.list = [];
      this.initData();
    }
  }

  @Watch("listorigin", { deep: true })
  freshData(newVal: any) {
    if (this.listorigin && this.listorigin.length > 0) {
      this.list = this.listorigin;
      this.initData();
    } else {
      this.list = [];
      this.initData();
    }
  }
  private initData() {
    if (this.list.length > 5) {
      this.showMoreIcon = true;
    }else{
      this.showMoreIcon = false;
    }

    // this.list.sort(this.sortData("desc", 3));
    if (this.list.length > 0) {
      this.myBubbleSrot(this.list, "desc", this.sortData("asc", 3));
      this.renderList = this.list.slice(0, 5);
      this.moreList = this.list.slice(5);
    } else {
      this.renderList = [];
      this.moreList = [];
    }
  }
  private sortData(type: string, index: number) {
    let key: any = "";
    this.slideTop.forEach((item, i) => {
      if (i === index) {
        key = item.sortKey;
      }
    });
    // return (a: any, b: any) => {
    //   const value1 = a[key];
    //   const value2 = b[key];

    //   return type === "desc" ? value2 < value1 : value1 < value2;
    // };
    return key;
  }

  private myBubbleSrot(list: any, direction: string, key: string) {
    for (let i = 0; i < list.length - 1; i++) {
      for (let j = 0; j < list.length - 1 - i; j++) {
        if (direction == "desc") {
          if (list[j][key] < list[j + 1][key]) {
            // console.log(
            //   "enter bubble sort desc",
            //   list[j][key],
            //   list[j + 1][key]
            // );
            const temp = list[j];
            list[j] = list[j + 1];
            list[j + 1] = temp;
          }
        } else {
          if (list[j][key] > list[j + 1][key]) {
            // console.log(
            //   "enter bubble sort asc",
            //   list[j][key],
            //   list[j + 1][key]
            // );

            const temp = list[j];
            list[j] = list[j + 1];
            list[j + 1] = temp;
          }
        }
      }
    }
  }
  private showMore() {
    this.showMoreIcon = false;
    this.showMoreList = true;
  }

  private getPrefix(isnew?: string, type?: string) {
    if (isnew) {
      return "新";
    }

    if (type == "GEM") {
      return "创";
    } else if (type == "STAR") {
      return "科创";
    }
  }

  private hideMore() {
    this.showMoreIcon = true;
    this.showMoreList = false;
  }

  private jumpAfenshi(stockcode: string, index: number, marketId: any) {
    const marketList: Array<string> = [];
    const codeList: Array<string> = [];
    const nameList: Array<string> = [];
    this.list.forEach((item: any, index: number) => {
      if (item.market_id) {
        marketList.push(item.market_id);
      } else {
        marketList.push("");
      }
      if (item.code) {
        codeList.push(item.code);
      } else {
        codeList.push("");
      }
      if (item.name) {
        nameList.push(item.name);
      } else {
        nameList.push("");
      }
    });
    const params = {
      stockcode: stockcode,
      marketid: marketId,
      namelist: nameList,
      marketlist: marketList,
      codelist: codeList
    };
    newFenshiJump(params);
    // win.F10Utils.fenshiJump({ stockcode: stockcode });
    win.hxmClickStat(
      `${this.maidian}all.${this.topNum}.${dataName[this.nowIndex]}.${
        this.sort
      }.${index}`,
      { url_ver: "F10-1725", targid: `agu_${stockcode}` }
    );
  }
}
